import * as React from "react";
const SvgFiRrSmilePlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-smile-plus_svg__a)">
      <path
        fill="#062147"
        d="M9 6c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7m3.236-4.672a.996.996 0 0 1-.057 1.406C12.039 18.864 10.76 20 9 20s-3.038-1.136-3.178-1.265a1 1 0 0 1 1.356-1.47c.003.003.83.735 1.822.735s1.817-.731 1.826-.738a1.003 1.003 0 0 1 1.41.066M6.5 15a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 15m6.5-1.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 13 13.5M24 4a1 1 0 0 1-1 1h-2v2a1 1 0 0 1-2 0V5h-2a1 1 0 0 1 0-2h2V1a1 1 0 0 1 2 0v2h2a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-smile-plus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSmilePlus;
